import { useEffect, useState } from 'react';

const useSelectLanguageField = ({ locale }) => {
  const { code = 'en-US' } = locale;
  const [defaultLanguage, setDefaultLanguage] = useState(code);

  // reading storage during render crashes SSR and hydrates to different markup
  useEffect(() => {
    const stored = window.localStorage.getItem('widgetDefaultLanguage');
    if (stored) {
      setDefaultLanguage(stored);
    }

    const handleLocalStorageLanguageChange = e => {
      if (e.key === 'widgetDefaultLanguage' && e.newValue) {
        setDefaultLanguage(e.newValue);
      }
    };

    window.addEventListener('storage', handleLocalStorageLanguageChange);

    return () => {
      window.removeEventListener('storage', handleLocalStorageLanguageChange);
    };
  }, []);

  const onWidgetDefaultLanguageChange = e => {
    setDefaultLanguage(e.target.value);
    window.localStorage.setItem('widgetDefaultLanguage', e.target.value);
  };

  return {
    defaultLanguage,
    onWidgetDefaultLanguageChange,
  };
};

export default useSelectLanguageField;
